<template>
  <div class="el-col-24">
    <h5 class="warp-title">机器人问答统计</h5>
    <div class="search">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="平台">
          <el-select v-model="searchForm.platformId" placeholder="平台">
            <el-option label="全部" value=""></el-option>
            <!-- <el-option label="说客" :value="0"></el-option>
            <el-option label="青豆" :value="1"></el-option>
            <el-option label="汉语吧" :value="2"></el-option>
            <el-option label="说客青豆" :value="10"></el-option> -->
            <el-option v-for="(item, index) in specialPlatformList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data-table">
      <table border="1">
        <tbody>
           <tr>
            <th>问答评价次数</th>
            <td>
              <el-link type="primary" :underline="false" @click="toProblemEvaluation">{{dataForm.sumCount}}</el-link>
            </td>
          </tr>
          <tr>
            <th>有帮助次数</th>
            <td>
              {{dataForm.validCount || 0}}
               <!-- <el-link type="primary" :underline="false">{{dataForm.validCount}}</el-link> -->
            </td>
          </tr>
          <tr>
            <th>没帮助次数</th>
            <td>
              {{dataForm.invalidCount || 0}}
               <!-- <el-link type="primary" :underline="false">{{dataForm.invalidCount}}</el-link> -->
            </td>
          </tr>
          <tr>
            <th>关键字搜索次数</th>
            <td>
               <el-link type="primary" :underline="false" @click="toProblemKeyword">{{dataForm.searchCount}}</el-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { queryProblemHelpRecordSumCount } from '../../api/statistics/index'
export default {
  name: 'Problem',
  created () {
    this.initData()
  },
  computed: {
    specialPlatformList () {
      return this.$store.state.Auth.specialPlatformList
    }
  },
  data () {
    return {
      time: '',
      searchForm: {
        startTime: '',
        endTime: '',
        platformId: ''
      },
      dataForm: {}
    }
  },
  methods: {
    toProblemKeyword () {
      this.$router.push({
        name: 'ProblemKeyword',
        query: {
          startTime: this.searchForm.startTime || '',
          endTime: this.searchForm.endTime || ''
        }
      })
    },
    toProblemEvaluation () {
      this.$router.push({
        name: 'ProblemEvaluation',
        query: {
          startTime: this.searchForm.startTime || '',
          endTime: this.searchForm.endTime || ''
        }
      })
    },
    onSubmit () {
      if (this.time && this.time.length === 2) {
        this.searchForm.startTime = this.time[0]
        this.searchForm.endTime = this.time[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.initData()
    },
    initData () {
      let data = {
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        platformId: this.searchForm.platformId
      }
      queryProblemHelpRecordSumCount(data).then(res => {
        if (res.data.resultCode === 0) {
          this.dataForm = res.data.resultData
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.data-table{
  /deep/ img{
    width: 400px;
  }
  margin-top: 20px;
  table{
    width: 100%;
    border: 1px solid #eee;
    color: #909399;
    font-size: 14px;
    tr{
      height: 48px;
      text-align: center;
      th{
        width: 150px;
      }
      td{
        padding: 20px;
        text-align: left;
        color: #444;
        line-height: 26px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/Problem.vue